const state = () => ({
  text: "Error",
  show: false,
});

const actions = {
  showError({ commit }, payload) {
    commit("SHOW_ERROR", payload);
    setTimeout(() => {
      commit("HIDE_ERROR");
    }, 4000);
  },
};

const mutations = {
  HIDE_ERROR(state) {
    state.text = "";
    state.show = false;
    //closeSnackBar(state);
  },
  SHOW_ERROR(state, message) {
    state.text = message;
    state.show = true;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
